import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import register from "../views/register.vue";
import DCIRegistration from "../views/DCIRegistration.vue";
import DigitalCopyrightRegistration from "../views/DigitalCopyrightRegistration.vue";
import WorksManagement from "../views/WorksManagement.vue";
import AccountCenter from "../views/AccountCenter.vue";
import CertificateVerification from "../views/CertificateVerification.vue";
import BasicInformation from "../views/AccountCenter/BasicInformation.vue";
import StaffAccount from "../views/AccountCenter/StaffAccount.vue";
import RealnameAuthentication from "../views/AccountCenter/RealnameAuthentication.vue";
import FinancialInformation from "../views/AccountCenter/FinancialInformation.vue";
import Invoiceinformation from "../views/AccountCenter/Invoiceinformation.vue";
import RechargeManagement from "../views/AccountCenter/RechargeManagement.vue";
import RealnameAuthenticationDelog from "../views/AccountCenter/RealnameAuthenticationDelog.vue";
import DCIRegistrationDelo from "../views/DCIRegistration/DCIRegistrationDelo.vue";
import DCIFeedBackSubmit from "../views/DCIRegistration/DCIFeedBackSubmit.vue";
import DigitalCopyrightRegistrationEdit from "../views/DigitalCopyrightRegistration/DigitalCopyrightRegistrationEdit.vue";
import InfoLock from "../views/InfoLock.vue";
import FollowUpBusiness from "../views/FollowUpBusiness.vue";
Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/home" },
  { path: "/login", component: Login, name: "login" },
  { path: "/register", component: register, name: "login" },
  {
    path: "/home",
    component: Home,
    name: "home",
    redirect: "/DCIRegistration",
    children: [
      {
        path: "/DCIRegistration",
        component: DCIRegistration,
      },
      {
        path: "/DigitalCopyrightRegistration",
        component: DigitalCopyrightRegistration,
      },
      {
        path: "/FollowUpBusiness",
        component: FollowUpBusiness,
      },
      {
        path: "/WorksManagement",
        component: WorksManagement,
      },
      {
        path: "/AccountCenter",
        component: AccountCenter,
        redirect: "/AccountCenter/RealnameAuthentication",
        children: [
          {
            path: "/AccountCenter/BasicInformation",
            component: BasicInformation,
          },
          {
            path: "/AccountCenter/StaffAccount",
            component: StaffAccount,
          },
          {
            path: "/AccountCenter/RealnameAuthentication",
            component: RealnameAuthentication,
          },
          {
            path: "/AccountCenter/FinancialInformation",
            component: FinancialInformation,
          },
          {
            path: "/AccountCenter/Invoiceinformation",
            component: Invoiceinformation,
          },
          {
            path: "/AccountCenter/RechargeManagement",
            component: RechargeManagement,
          },
        ],
      },
      {
        path: "/CertificateVerification",
        component: CertificateVerification,
      },
      {
        path: "/RealnameAuthenticationDelog",
        component: RealnameAuthenticationDelog,
      },
      {
        path: "/DCIRegistrationDelo",
        component: DCIRegistrationDelo,
      },
      {
        path: "/DCIFeedBackSubmit",
        component: DCIFeedBackSubmit,
      },
      {
        path: "/DigitalCopyrightRegistrationEdit",
        component: DigitalCopyrightRegistrationEdit,
      },
      {
        path: "/InfoLock",
        name: "InfoLock",
        component: InfoLock,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
